<template>
  <div class="row">
    <div class="col-12 mb-3">
      <h4 class="text-right text--orange">
        جستجو کاربران
      </h4>
    </div>
    <div class="col-12">
      <form class="text-right" v-on:keyup.enter="beforeSearch">
        <div class="row">
          <div class="col-12 col-sm-6 col-md-4 col-lg-6 col-xl-3">
            <div class="form-group" v-on:keyup.enter="beforeSearch">
              <label for="name" class="text-right mb-1">نام</label>
              <input
                id="name"
                v-model="filters.name"
                type="text"
                class="fv-sm form-control"
                placeholder="نام"
                keyup.enter="beforeSearch"
              />
            </div>
          </div>
          <div class="col-12 col-sm-6 col-md-4 col-lg-6 col-xl-3">
            <div class="form-group" v-on:keyup.enter="beforeSearch">
              <label for="family_name" class="text-right mb-1"
                >نام خانوادگی</label
              >
              <input
                id="family_name"
                v-model="filters.family_name"
                type="text"
                class="fv-sm form-control"
                placeholder="نام خانوادگی"
              />
            </div>
          </div>
          <div class="col-12 col-sm-6 col-md-4 col-lg-6 col-xl-3">
            <div class="form-group" v-on:keyup.enter="beforeSearch">
              <label for="username" class="text-right mb-1">نام کاربری</label>
              <input
                id="username"
                v-model="filters.username"
                type="text"
                class="fv-sm form-control"
                placeholder="نام کاربری"
              />
            </div>
          </div>
          <div class="col-12 col-sm-6 col-md-4 col-lg-6 col-xl-3">
            <div class="form-group" v-on:keyup.enter="beforeSearch">
              <label for="mobile" class="text-right mb-1">موبایل</label>
              <input
                id="mobile"
                v-model="filters.mobile"
                type="text"
                class="fv-sm form-control"
                placeholder="موبایل"
              />
            </div>
          </div>
          <div class="col-12 col-sm-6 col-md-4 col-lg-6 col-xl-3">
            <div class="form-group" v-on:keyup.enter="beforeSearch">
              <label for="email" class="text-right mb-1">ایمیل</label>
              <input
                id="email"
                v-model="filters.email"
                type="text"
                class="fv-sm form-control"
                placeholder="ایمیل"
              />
            </div>
          </div>
          <div class="col-12 col-sm-6 col-md-4 col-lg-6 col-xl-3">
            <div class="form-group" v-on:keyup.enter="beforeSearch">
              <label for="roles" class="text-right mb-1">سطح دسترسی</label>
              <appRolesSelect
                placeholder="سطح دسترسی"
                id="roles"
                v-model="filters.roles"
                :justId="true"
              />
            </div>
          </div>
          <div class="col-12 col-sm-6 col-md-4 col-lg-6 col-xl-3">
            <div class="form-group" v-on:keyup.enter="beforeSearch">
              <label for="province" class="text-right mb-1">استان</label>
              <appProvinceSelect
                placeholder="استان"
                id="province"
                v-model="filters.province_id"
              />
            </div>
          </div>
          <div class="col-12 col-sm-6 col-md-4 col-lg-6 col-xl-3">
            <div class="form-group" v-on:keyup.enter="beforeSearch">
              <label for="country" class="text-right mb-1">کشور</label>
              <appCountrySelectById
                placeholder="کشور"
                id="country"
                v-model="filters.country_id"
              />
            </div>
          </div>

          <div class="col-12 col-sm-6 col-md-8 col-lg-12 col-xl-6">
            <appRangeDatePicker
              fromLabel="از تاریخ ایجاد"
              toLabel="تا تاریخ ایجاد"
              v-model="filters.$and"
              id="createdAt"
            />
          </div>
          <div class="col-12 col-sm-6 col-md-4 col-lg-6 col-xl-3">
            <div class="form-group" v-on:keyup.enter="beforeSearch">
              <label for="premium_until" class="text-right mb-1"
                >دارای اشتراک تا تاریخ</label
              >
              <appDatePicker
                @input="filters.premium_until = { $lte: $event }"
                :value="filters.premium_until ? filters.premium_until.$lte : ''"
                id="premium_until"
              />
            </div>
          </div>
          <div class="col-12 col-sm-6 col-md-4 col-lg-6 col-xl-3">
            <div class="form-group" v-on:keyup.enter="beforeSearch">
              <label for="enable" class="text-right mb-1">فعال</label>
              <fv-switch
                id="enable"
                class="d-block"
                placeholder="فعال"
                v-model="filters.enabled"
              />
            </div>
          </div>
          <div class="col-12 col-sm-6 col-md-4 col-lg-6 col-xl-3">
            <div class="form-group" v-on:keyup.enter="beforeSearch">
              <label for="is_premium" class="text-right mb-1"
                >دارای اشتراک فعال</label
              >
              <fv-switch
                id="is_premium"
                class="d-block"
                placeholder="دارای اشتراک فعال"
                v-model="filters.is_premium"
              />
            </div>
          </div>

          <div class="col-12">
            <div class="row">
              <div class="col-12 col-sm-6 col-md-4 col-lg-6 col-xl-3">
                <div class="form-group" v-on:keyup.enter="beforeSearch">
                  <label for="sort" class="text-right mb-1"
                    >نمایش بر اساس</label
                  >
                  <fv-select
                    id="sort"
                    class="fv-form-control"
                    v-model="sort"
                    :options="[
                      { text: 'جدیدترین', value: '-_score,-created_at' },
                      { text: 'قدیمی ترین', value: '-_score,updated_at' },
                      {
                        text: 'بیشترین تعداد followers ها',
                        value: '-_score,-total_followers_count'
                      },
                      {
                        text: 'کمترین تعداد  followers ها',
                        value: '-_score,total_followers_count'
                      },
                      {
                        text: 'بیشترین تعداد following ها',
                        value: '-_score,-total_followings_count'
                      },
                      {
                        text: 'کمترین تعداد following ها',
                        value: '-_score,total_followings_count'
                      },
                      { text: 'بیشترین امتیاز', value: '-_score,-score' },
                      { text: 'کمترین امتیاز', value: '-_score,score' }
                    ]"
                  />
                </div>
              </div>
              <div class="col-12 col-sm-6 col-md-4 col-lg-6 col-xl-3">
                <div class="form-group" v-on:keyup.enter="beforeSearch">
                  <label for="perpage" class="text-right mb-1"
                    >تعداد نمایش</label
                  >
                  <fvSelect
                    class="fv-form-control"
                    id="perpage"
                    @input="changePerPage"
                    :value="pagination.per_page"
                    :options="$store.state.main.per_page"
                    placeholder="تعداد نمایش"
                  >
                  </fvSelect>
                </div>
              </div>
            </div>
          </div>

          <div class="col-12 text-left d-flex mt-3">
            <button
              type="button"
              @click="$router.push({})"
              class="btn btn-danger ml-auto"
            >
              حذف فیلترها
              <i class="fas fa-trash" />
            </button>
            <button
              type="button"
              @click="notificationDialog2 = true"
              class="btn btn-primary ml-3"
            >
              پوش‌نوتیفیکیشن به فیلترهای انجام شده
              <i class="fas fa-paper-plane"></i>
            </button>
            <button
              type="button"
              @click="notificationDialog = true"
              class="btn btn-primary ml-3"
            >
              پوش نوتیفیکیشن به همه کاربران
              <i class="fas fa-paper-plane"></i>
            </button>
            <button
              type="button"
              @click.prevent="beforeSearch"
              class="btn btn-info"
            >
              جستجو
              <i class="fas fa-search" />
            </button>
          </div>
        </div>
      </form>
      <p class="d-none" id="imageNOTI"></p>
      <hr />
    </div>
    <div class="col-12">
      <fvTable
        class="fv-size-lg"
        v-if="users.length > 0"
        :fields="fields"
        :rows="users"
      >
        <template slot="field-#" slot-scope="scope">
          <span>{{
            scope.index +
              1 +
              (page - 1) * (pagination.page === 1 ? 0 : pagination.per_page)
          }}</span>
        </template>
        <template slot="field-نام" slot-scope="scope">
          {{ scope.row.name || "---" }}
        </template>
        <template slot="field-نام خانوادگی" slot-scope="scope">
          {{ scope.row.family_name || "---" }}
        </template>
        <template slot="field-شماره موبایل" slot-scope="scope">
          <div dir="ltr">{{ scope.row.mobile || "---" }}</div>
        </template>
        <template slot="field-نام کاربری" slot-scope="scope">
          <div dir="ltr">{{ scope.row.username || "---" }}</div>
        </template>
        <template slot="field-followings" slot-scope="scope">
          <div class="d-flex align-items-center justify-content-center">
            <b class="ml-2">{{ scope.row.total_followings_count || 0 }}</b>
            نفر
          </div>
        </template>
        <template slot="field-followers" slot-scope="scope">
          <div class="d-flex align-items-center justify-content-center">
            <b class="ml-2">{{ scope.row.total_followers_count || 0 }}</b>
            نفر
          </div>
        </template>
        <template slot="field-عکس" slot-scope="scope">
          <div class="user_image_paginate">
            <img
              class="icon"
              v-if="scope.row.profile_picture && scope.row.profile_picture.path"
              :src="`${media_url}/${scope.row.profile_picture.path}?max=30`"
            />

            <div v-else><i class="far fa-user-circle defaultIcon" /></div>
          </div>
        </template>
        <template slot="field-تاریخ ثبت نام" slot-scope="scope">
          {{ $dateTimeFormat(scope.row.created_at) }}
        </template>
        <template slot="field-actions" slot-scope="scope">
          <button
            v-if="!data2.accountIds.includes(scope.row.id)"
            @click="addId(scope.row.id)"
            class="btn btn-success btn-sm"
          >
            انتخاب
            <i class="fa fa-check" />
          </button>
          <button
            v-if="data2.accountIds.includes(scope.row.id)"
            @click="deleteId(scope.row.id)"
            class="btn btn-danger btn-sm"
          >
            حذف
            <i class="fa fa-check" />
          </button>
        </template>
      </fvTable>
    </div>

    <div
      class="col-12 text-center mt-5"
      v-if="Object.keys(users).length && pagination.pages > 1"
    >
      <appPagination
        :pageCount="pagination.pages"
        v-model="page"
        @input="search"
      />
    </div>
    <fvDialog
      v-model="notificationDialog"
      class="col-12 col-md-8 col-lg-6 col-xl-4  py-3"
    >
      <div class="row d-flex align-items-center justify-content-between">
        <div class="col-12 col-xl-9 mb-3">
          <div class="form-group text-right">
            <label for="title" class="mb-1">عنوان نوتیفیکیشن</label>
            <input
              id="title"
              v-model="data.title"
              type="text"
              class="fv-sm form-control"
              placeholder="عنوان نوتیفیکیشن"
            />
          </div>
        </div>
        <div class="col-12 col-xl-9 mb-3">
          <div class="form-group text-right">
            <label for="content" class="mb-1">متن نوتیفیکیشن</label>
            <textarea
              id="content"
              rows="3"
              type="text"
              class="form-control"
              placeholder="متن پیامک"
              v-model="data.body"
            ></textarea>
          </div>
        </div>
        <div class="col-12 col-xl-9 mb-3">
          <div class="form-group text-right">
            <label for="content" class="mb-1">عکس نوتیفیکیشن</label>
            <imageUploader
              id="profile_picture"
              v-model="notificationImage"
              :multiple="false"
            />
          </div>
        </div>
        <div
          class="col-12 col-xl-3 mb-3 text-left"
          v-if="!sendNotificationConfirm"
        >
          <button
            @click="sendNotificationConfirm = true"
            type="button"
            class="btn btn-success mr-2"
          >
            ارسال
          </button>
        </div>
        <div class="col-12 col-xl-3 mb-3" v-else>
          <div>آیا مطمئن هستید؟</div>
          <button
            @click="sendNotifToAll"
            type="button"
            class="btn btn-success mr-2"
          >
            بلی
          </button>
          <button
            @click="notificationDialog = false"
            type="button"
            class="btn btn-danger mr-2"
          >
            لغو
          </button>
        </div>
      </div>
    </fvDialog>
    <fvDialog
      v-model="notificationDialog2"
      class="col-12 col-md-8 col-lg-6 col-xl-4  py-3"
    >
      <div class="row d-flex align-items-center justify-content-between">
        <div class="col-12 col-xl-9 mb-3">
          <div class="form-group text-right">
            <label for="title" class="mb-1">عنوان نوتیفیکیشن</label>
            <input
              id="title"
              v-model="data2.title"
              type="text"
              class="fv-sm form-control"
              placeholder="عنوان نوتیفیکیشن"
            />
          </div>
        </div>
        <div class="col-12 col-xl-9 mb-3">
          <div class="form-group text-right">
            <label for="content" class="mb-1">متن نوتیفیکیشن</label>
            <textarea
              id="content"
              rows="3"
              type="text"
              class="form-control"
              placeholder="متن پیامک"
              v-model="data2.body"
            ></textarea>
          </div>
        </div>
        <div class="col-12 col-xl-9 mb-3">
          <div class="form-group text-right">
            <label for="content" class="mb-1">عکس نوتیفیکیشن</label>
            <imageUploader
              id="profile_picture"
              v-model="notificationImage"
              :multiple="false"
            />
          </div>
        </div>
        <div
          class="col-12 col-xl-3 mb-3 text-left"
          v-if="!sendNotificationConfirm2"
        >
          <button
            @click="sendNotificationConfirm2 = true"
            type="button"
            class="btn btn-success mr-2"
          >
            ارسال
          </button>
        </div>
        <div class="col-12 col-xl-3 mb-3" v-else>
          <div>آیا مطمئن هستید؟</div>
          <button
            @click="sendNotifToSpecific"
            type="button"
            class="btn btn-success mr-2"
          >
            بلی
          </button>
          <button
            @click="notificationDialog2 = false"
            type="button"
            class="btn btn-danger mr-2"
          >
            لغو
          </button>
        </div>
      </div>
    </fvDialog>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import appProvinceSelect from "../components/appProvinceSelect";
import appRolesSelect from "../components/appRolesSelect";
import { API_MEDIA_URL } from "../env";
import appPagination from "../components/appPagination";
import appCategorySelect from "../components/appCategorySelect";
import appCountrySelectById from "../components/appCountrySelectById";
import appRangeDatePicker from "../components/appRangeDatePicker";
import appDatePicker from "../components/appDatePicker";
import FileSaver from "file-saver";
import appFileUploader from "../components/appFileUploader";
import axios from "axios";
import AppFileUploader2 from "../components/appFileUploader2.vue";
import Vue from "vue";
import imageUploader from "../components/AppPushImageUploader.vue";

export default {
  name: "pushNotifications",
  data() {
    return {
      ...mapActions("main", ["crud"]),
      users: [],
      fields: [
        "#",
        "نام",
        "نام خانوادگی",
        "نام کاربری",
        "شماره موبایل",
        "followings",
        "followers",
        "تاریخ ثبت نام",
        "عکس",
        "actions"
      ],
      query: {},
      page: 1,
      pagination: {
        per_page: 50
      },
      data: {
        title: "",
        body: "",
        imageUrl: ""
      },
      data2: {
        title: "",
        body: "",
        imageUrl: "",
        accountIds: []
      },
      filters: {},
      sort: "-_score,-created_at",
      media_url: API_MEDIA_URL,
      notification: {},
      notificationImage: {},
      notificationDialog: false,
      sendNotificationConfirm: false,
      sendNotificationLoading: false,
      notificationDialog2: false,
      sendNotificationConfirm2: false,
      sendNotificationLoading2: false
    };
  },
  components: {
    appProvinceSelect,
    appDatePicker,
    appRolesSelect,
    appPagination,
    appCategorySelect,
    appCountrySelectById,
    appRangeDatePicker,
    appFileUploader,
    AppFileUploader2,
    imageUploader
  },

  methods: {
    parseQueries() {
      const { query } = this.$route;
      const { page, filters, sort, per_page } = query;
      const filtersObj = filters ? JSON.parse(filters) : { enabled: true };

      this.sort = sort || "-_score,-created_at";
      this.filters = filtersObj;
      this.query = query;
      this.page = page ? parseInt(page) : 1;
      this.pagination.per_page = per_page;
    },
    async getData() {
      this.$store.commit("main/SET", { key: "loading", value: true });
      this.parseQueries();
      try {
        const apiFilters = await this.$generateFilter(this.filters);
        const user = await this.crud({
          action: "get",
          section: "accounts",
          query: `${this.$queryGenerator(apiFilters, this.sort)}${
            this.page >= 1 ? `&page=${this.page}` : ""
          }`,
          perPage: this.pagination.per_page
        });
        if (user.data && user.data.items) {
          const result = user.data.items;
          this.users = result;
          this.pagination = user.data.pagination;
        }
      } catch (e) {
        // console.log(e)
      } finally {
        this.$store.commit("main/SET", { key: "loading", value: false });
      }
    },
    async downloadExcel() {
      this.$store.commit("main/SET", { key: "loading", value: true });
      try {
        const filters = await this.$generateFilter(this.filters);

        const data = {
          filters,
          page: this.page,
          limit: this.pagination.per_page
        };
        const users = await this.crud({
          action: "post",
          section: "export/accounts",
          data,
          perPage: this.pagination.per_page,
          requestOptions: { responseType: "blob" }
        });
        console.log(users.data);
        if (users.data) {
          FileSaver.saveAs(users.data, "accounts.csv");
        }
      } catch (e) {
        console.log(e);
      } finally {
        this.$store.commit("main/SET", { key: "loading", value: false });
      }
    },
    async addId(id) {
      console.log("added");
      this.data2.accountIds.push(id);
      console.log("ids", this.data2.accountIds);
    },
    async deleteId(id) {
      console.log("deleted");
      const filteredData = this.data2.accountIds.filter(acc => acc !== id);
      this.data2.accountIds = filteredData;
      console.log("ids", this.data2.accountIds);
    },

    async sendNotification() {
      console.log("notif sent", this.data);
      //   this.$store.commit("main/SET", { key: "loading", value: true });

      //   if (this.sendNotificationLoading) return;

      //   this.sendNotificationLoading = true;

      //   try {
      //     const filters = await this.$generateFilter(this.filters);

      //     const data = { filters, message: { notification: this.notification } };
      //     const users = await this.crud({
      //       action: "post",
      //       section: "notifications/send",
      //       data
      //     });

      //     console.log(users);
      //   } catch (e) {
      //     console.log(e);
      //   } finally {
      //     this.$store.commit("main/SET", { key: "loading", value: false });
      //     this.sendNotificationLoading = false;
      //     this.sendNotificationConfirm = false;
      //     this.notificationDialog = false;
      //   }
    },
    async sendNotifToAll() {
      const imageUrl = document.getElementById("imageNOTI").innerHTML;
      console.log("imageyrl", imageUrl);
      this.data.imageUrl = imageUrl;
      this.$store.commit("main/SET", { key: "loading", value: true });

      if (this.sendNotificationLoading) return;

      this.sendNotificationLoading = true;

      try {
        console.log("notif", this.data);
        const token = Vue.$cookies.get("accessToken");

        const res = await axios.post(
          "https://dev.api.ighe3.com/v5/notification/send/all",
          JSON.stringify(this.data),
          {
            headers: {
              Authorization: `Bearer ${token}`,
              Accept: "application/json",
              "Content-Type": "application/json"
            }
          }
        );
        console.log(res);
      } catch (e) {
        console.log(e);
      } finally {
        this.$store.commit("main/SET", { key: "loading", value: false });
        this.sendNotificationLoading = false;
        this.sendNotificationConfirm = false;
        this.notificationDialog = false;
      }
    },
    async sendNotifToSpecific() {
      const imageUrl = document.getElementById("imageNOTI").innerHTML;
      console.log("imageyrl", imageUrl);
      this.data2.imageUrl = imageUrl;
      this.$store.commit("main/SET", { key: "loading", value: true });

      if (this.sendNotificationLoading2) return;

      this.sendNotificationLoading2 = true;

      try {
        console.log("notifSpecific", this.data2);
        const token = Vue.$cookies.get("accessToken");

        const res = await axios.post(
          "https://dev.api.ighe3.com/v5/notification/send/specific",
          JSON.stringify(this.data2),
          {
            headers: {
              Authorization: `Bearer ${token}`,
              Accept: "application/json",
              "Content-Type": "application/json"
            }
          }
        );

        console.log(res);
      } catch (e) {
        console.log(e);
      } finally {
        this.$store.commit("main/SET", { key: "loading", value: false });
        this.sendNotificationLoading2 = false;
        this.sendNotificationConfirm2 = false;
        this.notificationDialog2 = false;
      }
    },
    async search() {
      this.filters = await this.$validateFilter(this.filters);
      await this.$router.push({
        query: {
          filters:
            Object.keys(this.filters).length > 0
              ? JSON.stringify(this.filters)
              : undefined,
          sort: this.sort || undefined,
          page: this.page,
          per_page: this.pagination.per_page
        }
      });
    },
    beforeSearch() {
      this.page = 1;
      this.search();
    },
    changePerPage(value) {
      this.pagination.per_page = value;
      this.beforeSearch();
    }
  },

  async created() {
    await this.getData();
  },
  watch: {
    "$route.query"() {
      this.getData();
    },
    notificationImage: {
      handler(val) {
        this.notification.image_url = val.path;
      },
      deep: true
    },
    "$route.params.id": () => {
      // _vm.$forceUpdate();
    }
  }
};
</script>
<style lang="scss">
.user_image_paginate {
  & .icon {
    border-radius: 50%;
  }

  & .defaultIcon {
    font-size: 40px;
  }
}
</style>
